import type { RenderObject } from '@v2/contracts'
import { intersectRayOBB, type Mat4, type Ray } from '@v2/math'

export interface PickObject { readonly source: RenderObject; readonly model: Mat4 }

/** Picking mirrors compositing: foreground depth wins before world depth. */
export function pickObjects(ray: Ray, objects: Iterable<PickObject>, mode: 'action' | 'inspect' = 'action'): string | null {
  let world: PickObject | undefined
  let foreground: PickObject | undefined
  let worldDistance = Infinity
  let foregroundDistance = Infinity
  for (const object of objects) {
    if (object.source.decorative) continue
    const distance = intersectRayOBB(ray, object.model)
    if (distance === null) continue
    if (object.source.layer === 'foreground') {
      if (distance < foregroundDistance) { foreground = object; foregroundDistance = distance }
    } else if (distance < worldDistance) { world = object; worldDistance = distance }
  }
  // Visible noninteractive pieces still occlude objects behind them. Filtering
  // eligibility before the intersection would allow accidental click-throughs.
  const hit = foreground ?? world
  const eligible = mode === 'inspect' ? hit?.source.inspectable : hit?.source.interactive
  return eligible ? hit!.source.id : null
}
